var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","color":"grey","loading":_vm.loading},on:{"click":() => _vm.removeContract()}},[_c('v-icon',{attrs:{"light":""}},[_vm._v(" mdi-delete-outline ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }